import React, { createContext, useContext, useEffect, useState } from "react";
import { apiFetch } from "../utils/api";

const TokenContext = createContext({ expired: false, alert: false, daysRemaining: null });

export function useToken() {
  return useContext(TokenContext);
}

export function TokenProvider({ children }) {
  const [status, setStatus] = useState({ expired: false, alert: false, daysRemaining: null });

  useEffect(() => {
    apiFetch("/api/kizeo/token_status")
      .then((d) => setStatus({ expired: !!d.expired, alert: !!d.alert, daysRemaining: d.days_remaining ?? null }))
      .catch(() => {});
  }, []);

  return <TokenContext.Provider value={status}>{children}</TokenContext.Provider>;
}
